window.casino = window.casino || {};
var repos = window.casino.repos = window.casino.repos || {};

repos.base = {
    // Resolve a relative API path against casino.config._apiBase if set.
    // When _apiBase is undefined (main app), returns the path unchanged.
    // When _apiBase is set (web component), prepends it.
    // Example: makeUrl('api/session') → 'https://mcasino.supersport.hr/api/session'
    makeUrl: function (path) {
        var base = casino.config._apiBase;
        if (base) {
            return base.replace(/\/+$/, '') + '/' + path.replace(/^\/+/, '');
        }
        return path;
    },
    headers: function () {
        return {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'RequestVerificationToken': casino.config.antiForgeryToken
        }
    },
    credentials: 'include',
    serializeGetParams: function (obj) {
        return '?' + Object.keys(obj).reduce(function (a, k) {
            a.push(k + '=' + encodeURIComponent(obj[k]));
            return a
        }, []).join('&')
    },
    checkResponse: function (response) {
        if (response.status !== 200) {
            throw response;
        }
        return response;
    },
    handleNetworkException: function (error) {
        // Ako je dokument skriven,ne trigeriramo fatalni error screen — ovo sprječava
        // "Greška u komunikaciji" kada se korisnik vrati u browser
        if (document.hidden) {
            console.warn('Network error ignored (document hidden):', error);
            return;
        }
        if (casino.repos.base.networkErrorsListener != null)
            casino.repos.base.networkErrorsListener(error);
    },
    networkErrorsListener: null
};